import { Component } from '@angular/core';

@Component({
    templateUrl: './auth-layout.component.html',
})
export class AuthLayoutComponent {
}
